import styled from '@emotion/styled';

export const PdfContainer = styled.div`
  height: 100%;
`;
